import React from 'react';
import CKTextEditor from "../CKTextEditor";
import Icon from '../../icons';

const FormTextEditor = (field) => (
    <div className={`formGroup ${field.wrapperClass ? field.wrapperClass : ''} ${(field.meta.touched && field.meta.error) ? 'errorMsg' : ''}`}>
        {field.label && <div className={field.labeldivclass}>
        <label>{field.label}{field.isRequired && <sup>*</sup>}
            {field.helpText && <span className="quickTooltip-bottom" data-quicktooltip={field.helpText}><Icon name="info" className="icon ml greyInfoIcon" /></span>}
        </label></div>}
        <CKTextEditor
            editorData={field.input.value}
            placeholderText={field.input.placeholder}
            disableResize={true}
            class={field.class}
            onChange={(editorContent) => {
                if (editorContent.replace(/[<br><p></p>&nbsp;]/g, '').trim() !== "") {
                    field.input.onChange(editorContent);
                }
                else if(editorContent.trim().length==0){
                    field.input.onChange(editorContent);
                }
            }}
        />

        {field.meta.touched && field.meta.error &&
            <span>{field.meta.error}</span>}
    </div>
)

export default FormTextEditor;